import { render } from "./Restore.vue?vue&type=template&id=f9da35c8"
import script from "./Restore.vue?vue&type=script&lang=js"
export * from "./Restore.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__